import { render, staticRenderFns } from "./pubModal.vue?vue&type=template&id=f1b48870"
import script from "./pubModal.vue?vue&type=script&lang=js"
export * from "./pubModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports